import { CompositeScreenProps, useNavigation } from '@react-navigation/native'
import React, { useState } from 'react'

import { NameInput } from 'pages/CoachOnboarding/subcomponents/NameInput'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'

import { links } from 'utils/constants'

import { Program } from 'types/program'

export const ProgramNamePage = ({ route }: CompositeScreenProps<any, any>) => {
  const programData = route?.params?.program as Program | undefined
  const navigation = useNavigation<any>()

  const [upspaceTitle, setUpspaceTitle] = useState<string | null>()

  const handleNextPress = () => {
    if (!upspaceTitle?.length) return
    if (!programData) return
    programData.title = upspaceTitle ?? ''
    navigation.navigate(links.PROGRAM_IMAGE_PAGE, {
      program: programData,
    })
  }

  return (
    <Box flex={1} backgroundColor='white'>
      <BottomSheetNav
        withNext
        withBack
        rightButtonTitle='Next'
        rightButtonColor={upspaceTitle?.length ? 'v2primary' : 'grey'}
        backgroundColor='white'
        onNextPress={handleNextPress}
      />
      <NameInput
        input={upspaceTitle}
        setInput={setUpspaceTitle}
        textColor='black'
        promptTitle='Name your program.'
        promptSubtitle='We recommend naming it something specific and catchy like ‘Sofa to So Fast’'
        inputPlaceholder='Program Name'
      />
    </Box>
  )
}
